import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoginContextProvider } from './context/LoginContext';
import { setupFetchInterceptor } from './apis/apiFetch';
import { loadConfig } from './config/runtimeConfig';
import { DriveContextProvider } from './context/DriveContext';

// Suppress known unhandled promise rejections from third-party libraries (e.g. react-google-recaptcha async-script loader)
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && typeof event.reason.message === 'string' && event.reason.message.includes('Timeout (')) {
    console.warn('Suppressed expected reCAPTCHA script timeout error:', event.reason.message);
    event.preventDefault(); // Prevents the React Error Overlay from crashing the screen
  }
});

// ─── Boot Sequence ─────────────────────────────────────────────
// 1. Load runtime config.json (before anything else)
// 2. Set up fetch interceptor (needs API_BASE_URL from config)
// 3. Render the React app
loadConfig().then(() => {
  setupFetchInterceptor();

  const queryClient = new QueryClient();
  const container = document.getElementById('root');

  if (!container) {
    throw new Error("Root container not found. Ensure there is a div with id='root' in your index.html.");
  }

  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <LoginContextProvider>
            <DriveContextProvider>
              <App />
            </DriveContextProvider>
          </LoginContextProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});